const getError = state => state.error;

export default getError;
